import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['categories']);

export const categoriesQueryKeys = {
  all: builder(),
  one: (id: number) => builder('one', id),
};
